import {
  GET_LABREQUESTREPORTROI_FAIL,
  GET_LABREQUESTREPORTROI_SUCCESS,
  GET_LABREQUESTREPORTROIS_FAIL,
  GET_LABREQUESTREPORTROIS_SUCCESS,
  ADD_LABREQUESTREPORTROI_SUCCESS,
  ADD_LABREQUESTREPORTROI_FAIL,
  UPDATE_LABREQUESTREPORTROI_SUCCESS,
  UPDATE_LABREQUESTREPORTROI_FAIL,
  DELETE_LABREQUESTREPORTROI_SUCCESS,
  DELETE_LABREQUESTREPORTROI_FAIL,  
  SET_STATE_LABREQUESTREPORTROI
} from "./actionTypes";

const INIT_STATE = {
  labRequestReportRois: [],
  labRequestReportRoi: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestReportRois = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTREPORTROIS_SUCCESS:
      return {
        ...state,
        labRequestReportRois: action.payload.labRequestReportRois,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTREPORTROI:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTREPORTROIS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTREPORTROI_SUCCESS:
      return {
        ...state,
        labRequestReportRois: [...state.labRequestReportRois, action.payload],
      };

    case ADD_LABREQUESTREPORTROI_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTREPORTROI_SUCCESS:
      return {
        ...state,
        labRequestReportRois: state.labRequestReportRois.map(labRequestReportRoi =>
          labRequestReportRoi.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestReportRoi }
            : labRequestReportRoi
        ),
      };

    case UPDATE_LABREQUESTREPORTROI_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTREPORTROI_SUCCESS:
      return {
        ...state,
        labRequestReportRois: state.labRequestReportRois.filter(
          labRequestReportRoi => labRequestReportRoi.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTREPORTROI_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTREPORTROI_SUCCESS:
      return {
        ...state,
        labRequestReportRoi: action.payload,
      };

    case GET_LABREQUESTREPORTROI_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestReportRois;
